import { ALL_CLASSES_RETRIEVED } from './class-list-actions';

const initialState = [];

/**
 * Class List Reducer
 *
 * Consumes ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case ALL_CLASSES_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/class-list/class-list-reducer.js